import { Input, ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { I18NService } from './i18n.service';

/**
 * Usage: <i18n [v]="'send'"></i18n> 
*/
@Component({
	selector: 'i18n',
	template: '{{translate(v)}}',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: []
})
export class I18nComponent implements OnInit {

	@Input() v : string;

	/*
	 * Contructor.
	 */
	constructor(public service : I18NService) {
	}

	ngOnInit(): void {
	}

	translate(aKey: string) {
		//-- console.log("translate by i18n.component")
		return this.service.v(aKey);
	}

}
